module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cargoCarrier":"Cargo Carrier","searchForCargoCarrier":"Search for cargo carrier","failedToFetch":"Failed to fetch cargo carriers"},"no":{"cargoCarrier":"Lastebærer","searchForCargoCarrier":"Søk etter lastebærer","failedToFetch":"Kunne ikke hente lastebærere"}}')
  delete Component.options._Ctor
}
